import Cookies from "js-cookie";

/** Offices the signed-in user can access (code + display label). */
export const getAssignedOfficeOptions = () => {
  const seen = new Set();
  const options = [];

  const add = (officeCode, label) => {
    const code = (officeCode || "").toString().trim();
    if (!code || seen.has(code)) return;
    seen.add(code);
    options.push({
      officeCode: code,
      label: (label || code).toString().trim() || code,
    });
  };

  const addOfficeCodesCsv = (csv) => {
    if (!csv) return;
    String(csv)
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean)
      .forEach((code) => add(code, code));
  };

  try {
    addOfficeCodesCsv(Cookies.get("officeCodes"));
    addOfficeCodesCsv(localStorage.getItem("officeCodes"));

    const orgData = JSON.parse(localStorage.getItem("organizationData") || "[]");
    if (Array.isArray(orgData)) {
      orgData.forEach((org) => {
        add(
          org.officeCode,
          org.organizationName || org.officeName || org.officeCode
        );
      });
    }
  } catch {
    // ignore parse errors
  }

  const active = Cookies.get("officeCode");
  if (active) add(active, active);

  return options;
};

export const getAssignedOfficeCodes = () =>
  getAssignedOfficeOptions().map((office) => office.officeCode);

export const getDefaultAssignedOfficeCode = () => {
  const options = getAssignedOfficeOptions();
  const active = Cookies.get("officeCode") || "";
  if (active && options.some((o) => o.officeCode === active)) return active;
  return options[0]?.officeCode || active || "";
};

/** Prefer office on a config row, else the page-selected office. */
export const resolveOfficeScope = (row, fallbackOfficeCode = "") => {
  const fromRow = (row?.officeCode || row?.originatorId || "").toString().trim();
  if (fromRow && fromRow !== "--") return fromRow;
  const fallback = (fallbackOfficeCode || "").toString().trim();
  return fallback || undefined;
};
